<template>
  <div class="phone-input">
    <div class="input-wrapper">
      <label v-if="inputLabel" class="input-label">{{inputLabel}}</label>
      <input
          :autocomplete="autocomplete"
          :id="id"
          maxlength="50"
          :name="id"
          placeholder="enter phone number or email"
          v-model="input"
          @change="validateInput">
    </div>
    <div v-if="inputError" class="error-message">{{inputError}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      autocomplete: String,
      fieldToUpdate: String,
      id: String,
      inputLabel: String,
    },

    name: 'FormInput',

    data() {
      return {
        input: null,
        inputError: null,
      }
    },

    methods: {
      validateInput() {

        if (!this.input.includes('@')) {
          this.input = this.input?.replace(/\D/g, "")
          const phone_regex = /^((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/,
              isValid = phone_regex.test(this.input),
              error = isValid ? null : 'invalid phone number',
              phoneValue = isValid ? this.input : null

          this.inputError = error
          this.$emit('updateInput', this.fieldToUpdate, phoneValue)
        } else {
          const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              isValid = email_regex.test(this.input.toLowerCase()),
              error = isValid ? null : 'invalid email',
              emailValue = isValid ? this.input : null

          const encodedEmail = emailValue != null ? btoa(emailValue) : null;
          this.inputError = error
          this.$emit('updateInput', this.fieldToUpdate, encodedEmail)
        }
      },
    }
  }
</script>

<style lang="sass">
.phone-input
  .input-wrapper
    display: inline-flex
    flex-direction: column
    align-items: flex-start
    margin-top: .5rem
    width: 100%

  .input-label
    font-size: .9rem
    margin: 0 0 .25rem 0

  input
    margin-bottom: .25rem
    width: 95%

  input::-webkit-input-placeholder
      color: #c6cad0
</style>
